import PropTypes from 'prop-types';
import React from 'react';

const StatusOption = ({ optionText, updateStatusFilter, checked }) => (
  <div className="c-checkbox u-mr">
    <input
      className="c-checkbox__input"
      type="checkbox"
      checked={checked}
      id="statusField"
      onChange={e => updateStatusFilter(e)}
      value={'true'}
    />

    <label className="c-checkbox__label" htmlFor="statusField">
      <span className="c-checkbox__trigger" />
      <span className="c-checkbox__text">{optionText}</span>
    </label>
  </div>
);

StatusOption.propTypes = {
  updateStatusFilter: PropTypes.func.isRequired,
  optionText: PropTypes.string,
  checked: PropTypes.bool,
};

export default StatusOption;
